import { render, staticRenderFns } from "./ChatPresence.vue?vue&type=template&id=2c304baa"
import script from "./ChatPresence.vue?vue&type=script&lang=js"
export * from "./ChatPresence.vue?vue&type=script&lang=js"
import style0 from "./ChatPresence.vue?vue&type=style&index=0&id=2c304baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports